<template lang="pug" src="./option-classes.pug"></template>
<style lang="scss" src="./option-classes.scss" scoped></style>

<script>
import { mapState } from 'vuex';
import request from '@/utils/request';

import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import validate from '@/mixins/validate';

export default {
    mixins: [validate, validationMixin],
    data: () => ({
        saveModal: false,
        removeModal: false,
        chosenClass: {
            className: null
        }
    }),
    validations: {
        chosenClass: {
            className: {
                required
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.data.optionClasses
        }),
        headers() {
            return ['className', 'actions'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.OptionClasses.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        isEditingMode() {
            return !!this.chosenClass.id;
        },
        saveModalTitle() {
            return this.isEditingMode ? 'edit' : 'create';
        }
    },
    created() {
        this.$store.dispatch('data/getOptionClasses');
    },
    methods: {
        openModal(optionClass, modal) {
            this.$data[modal] = true;

            if (!optionClass) return;

            this.chosenClass = { ...optionClass };
        },
        async saveOptionClass() {
            if (this.$v.chosenClass.$invalid) {
                this.$v.chosenClass.$touch();
                return;
            }

            const { id } = this.chosenClass;
            const method = id ? 'put' : 'post';
            const url = id ? `/admin/option/classes/${id}` : '/admin/option/classes';

            await request({
                method, url,
                data: this.chosenClass
            }).then(res => {
                if (res.data) {
                    const index = this.items.findIndex(it => it.id === res.data.id);

                    if (index === -1) {
                        this.items.unshift(res.data);
                    } else {
                        this.$set(this.items, index, res.data);
                    }

                    this.$nextTick(() => {
                        this.closeModal('saveModal');
                    });
                }
            }).catch(error => this.errorHandler(error));
        },
        async remove() {
            await request({
                method: 'delete',
                url: `admin/option/classes/${this.chosenClass.id}`
            }).then(res => {
                if (res.status === 204) {
                    const newItems = this.items.filter(it => it.id !== this.chosenClass.id);
                    this.$store.commit('data/SET_OPTION_CLASSES', newItems);

                    this.closeModal('removeModal');
                }
            }).catch(error => this.errorHandler(error));
        },
        errorHandler(error) {
            const message = error.response && error.response.data && error.response.data.error;

            if (message) {
                this.$store.dispatch('alert/addMessage', {
                    message: `optionClasses.${message}`,
                    time: 2000
                });
            }
        },
        closeModal(modal) {
            this.$data[modal] = false;

            this.chosenClass = {
                className: null
            };

            this.$v.chosenClass.$reset();
        }
    }
};
</script>
